import React from "react";

export default function Image({ src, alt, caption, className = "", ...props }) {
  if (!src) return null;

  return (
    <figure className={`story-image-container ${className}`}>
      <img
        src={`${process.env.PUBLIC_URL}/images/${src}`}
        alt={alt || caption || "Story illustration"}
        className="story-image"
        loading="lazy" // Improves performance, good for this app
        {...props}
      />
      {caption && (
        <figcaption className="story-image-caption">{caption}</figcaption>
      )}
    </figure>
  );
}
